import { PublicUrlAdapter } from '@magicdoorinc/file';
import { createSignal, onCleanup } from 'solid-js';
import { leaseTransactionReceiptRepository } from '~/repositories/leaseTransactionReceiptRepository';
import { fileService } from '~/utils/file';
import { printUrl, resetPrintSystem } from '~/utils/print';

export const printReceiptPdf = async (fileId?: string): Promise<HTMLIFrameElement | undefined> => {
  if (!fileId) return;
  const result = await fileService.buildFileUrl(new PublicUrlAdapter({ reference: fileId }));
  if (!result?.url) return;
  return printUrl(result.url);
};

export const printLeaseTransactionReceipt = async (leaseId: string, transactionId: string) => {
  const receipt = await leaseTransactionReceiptRepository.getReceipt(leaseId, transactionId);
  return printReceiptPdf(receipt.file?.id);
};

export const usePrintReceipt = () => {
  const [printIFrame, setPrintIFrame] = createSignal<HTMLIFrameElement>();

  const replacePrintIFrame = (iframe?: HTMLIFrameElement) => {
    resetPrintSystem(printIFrame());
    setPrintIFrame(iframe);
  };

  const printFile = async (fileId?: string) => {
    replacePrintIFrame(await printReceiptPdf(fileId));
  };

  const printTransaction = async (leaseId: string, transactionId: string) => {
    replacePrintIFrame(await printLeaseTransactionReceipt(leaseId, transactionId));
  };

  onCleanup(() => resetPrintSystem(printIFrame()));

  return { printFile, printTransaction };
};
